module.exports = __webpack_public_path__ + "static/media/woman-cta.5c2b66ea.png";